import { Col, Row } from "react-bootstrap";
import { SliderPage } from ".";
import { useProduct } from "../adapters/uplist";
import {
  PREMIUM_VIDEO_SAMPLES,
  SLIDESHOW_SAMPLES,
  STANDARD_VIDEO_SAMPLES,
} from "../assets/images/samples";
import { InternalSection } from "../components";
import { BlockCheckbox, InlineCheckbox, Select } from "../components/fields";
import { Notes } from "../components/fields/Notes";
import AddOnSection from "../components/order/AddOnSection";
import { useProductWatcher } from "../context/ProductWatcherContext";
import {
  PREMIUM_VIDEO_SKUS,
  TWILIGHT_VIDEO_SKUS,
  VIDEO_APPT_SKUS,
} from "../helpers/constants";
import { useProductDiscount } from "../hooks";
import { TWILIGHT_VIDEO_SAMPLES } from "../assets/images/samples/twilight";
import { SOCIAL_MEDIA_SAMPLES } from "../assets/images/samples/video";

const VideoPage = () => {
  const { standard_video_sku, premium_video_sku, twilight_video_sku } =
    useProductWatcher();
  const { data: addlVideoTimeProduct } = useProduct("6103");

  const addlVideoTimeValue = (value, price) => {
    const label = `${value * 30} Second Video Extension +$${price * value}`;
    return { value, label };
  };

  const addlVideoTimeOptions = () => {
    return [...Array(4)].map((_, value) => {
      value++;
      return addlVideoTimeValue(value, addlVideoTimeProduct?.price);
    });
  };

  const aerial_video_discount = useProductDiscount({
    other_product_skus: ["4001"],
    product_sku: premium_video_sku,
    discount_sku: "4002",
  });

  return (
    <SliderPage title="Video">
      <Row>
        <BlockCheckbox
          sku="1312"
          label='Basic "Ken Burns" Slideshow Video'
          modal={{ urls: SLIDESHOW_SAMPLES, vimeo: true }}
        />
        {standard_video_sku && (
          <BlockCheckbox
            key={standard_video_sku}
            sku={standard_video_sku}
            label="Standard Video Shoot"
            modal={{ urls: STANDARD_VIDEO_SAMPLES, vimeo: true }}
          />
        )}
        {premium_video_sku && (
          <BlockCheckbox
            key={premium_video_sku}
            sku={premium_video_sku}
            label="Premium Video Shoot"
            modal={{ urls: PREMIUM_VIDEO_SAMPLES, vimeo: true }}
            discount={aerial_video_discount}
          />
        )}
      </Row>
      <AddOnSection
        title="Video Add-Ons"
        show_skus={VIDEO_APPT_SKUS}
        addon_skus={["6103", "6100", "6101", "6109", ...TWILIGHT_VIDEO_SKUS]}
      >
        <Row>
          <AddOnSection
            show_skus={PREMIUM_VIDEO_SKUS}
            addon_skus={TWILIGHT_VIDEO_SKUS}
          >
            {twilight_video_sku && (
              <BlockCheckbox
                key={twilight_video_sku}
                sku={twilight_video_sku}
                label="Twilight Video Shoot"
                modal={{ urls: TWILIGHT_VIDEO_SAMPLES, vimeo: true }}
              />
            )}
          </AddOnSection>
          <BlockCheckbox
            sku="6109"
            modal={{ urls: SOCIAL_MEDIA_SAMPLES, vimeo: true }}
          />
        </Row>

        <Row className="mb-4">
          <Col sm={6} xl={4}>
            <Select
              sku="6103"
              label="Additional Video Time"
              options={addlVideoTimeOptions()}
            />
          </Col>
        </Row>
        <InlineCheckbox sku="6100" />
        <InlineCheckbox sku="6101" />
      </AddOnSection>
      <InternalSection>
        <InlineCheckbox sku="6110" />
        <InlineCheckbox sku="6111" />
        <InlineCheckbox sku="6104" />
        <InlineCheckbox sku="6105" />
        <Notes name="notes.video" label="Video Notes" />
      </InternalSection>
    </SliderPage>
  );
};

export default VideoPage;
